import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import LButton from '@/components/core/Button.vue'
import { useContext } from '@/composables/context'
import { Transportation } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationLocationUpdateListItem.vue',
  props: {
    transportation: null,
    selectedTransportations: null
  },
  setup(__props: any) {

const props = __props as {
  transportation: Transportation
  selectedTransportations: string[]
};



const { i18n } = useContext()

const title = computed(
  () =>
    props.transportation.label ||
    i18n.t(`transportation.${props.transportation.type}.label`).toString(),
)

const isSelected = computed(() =>
  props.selectedTransportations.includes(props.transportation._id),
)

return { __sfc: true,props, i18n, title, isSelected, LButton }
}

})